import { IDiscountRepository } from '../domain/IDiscountRepository'

export class DownloadAssociations {
  constructor(private readonly discountRepository: IDiscountRepository) {}

  async execute(sellerId: number, sellerName: string) {
    return this.discountRepository.downloadAssociations(sellerId, sellerName)
  }
}
